import { useEffect } from "react";

import { useAppSelector } from "Store/hooks";

import { userAccessStateByUserIdSelector } from "../userAccess.selectors";

import { useGetUserAccessByUserId } from "./useGetUserAccessByUserId";

export const useUserAccessByUserId = (projectId: string, userId: string) => {
  const action = useGetUserAccessByUserId();
  const state = useAppSelector(state =>
    userAccessStateByUserIdSelector(state, { userId })
  );

  useEffect(() => {
    if (state?.isLoading === undefined) action(projectId, userId);
  }, [state, action, projectId, userId]);

  return [state?.data, state?.isLoading, state?.error, action] as const;
};
